/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanyProposalSettingsResourceValidation
 */
export interface ClientCompanyProposalSettingsResourceValidation {
    /**
     * 
     * @type {number}
     * @memberof ClientCompanyProposalSettingsResourceValidation
     */
    administratorValidationThreshold?: number;
}

/**
 * Check if a given object implements the ClientCompanyProposalSettingsResourceValidation interface.
 */
export function instanceOfClientCompanyProposalSettingsResourceValidation(value: object): value is ClientCompanyProposalSettingsResourceValidation {
    return true;
}

export function ClientCompanyProposalSettingsResourceValidationFromJSON(json: any): ClientCompanyProposalSettingsResourceValidation {
    return ClientCompanyProposalSettingsResourceValidationFromJSONTyped(json, false);
}

export function ClientCompanyProposalSettingsResourceValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyProposalSettingsResourceValidation {
    if (json == null) {
        return json;
    }
    return {
        
        'administratorValidationThreshold': json['administratorValidationThreshold'] == null ? undefined : json['administratorValidationThreshold'],
    };
}

export function ClientCompanyProposalSettingsResourceValidationToJSON(value?: ClientCompanyProposalSettingsResourceValidation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'administratorValidationThreshold': value['administratorValidationThreshold'],
    };
}

